import { Component } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { BinsService } from '../service/bins.service';
import { ValidationService } from '../service/validation.service';
import { formatDate } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalizationService } from '../service/localization.service';
import { ModalAlertService } from '../service/alert-modal.service';
import { ThemeService } from '../service/theme.service';
import { CognitoService } from '../service/cognito.service';
import { SystemMessageService } from '../service/system-message.service';
import { environment } from '../environments/environment';
import { MarketSegment } from '../constants/market-segments';
import { RoleService } from '../service/role.service';
import { IotService } from '../service/iot.service';
import { DashboardService } from '../service/dashboard.service';
import { BinUsage } from '../constants/bin-usage';
import { CustomMultiSelectComponent } from '../custom-multi-select/custom-multi-select.component';

interface Device {
  thing_name: string;
}

@Component({
    selector: 'app-bin-update',
    templateUrl: './bin-update.component.html',
    styleUrls: ['./bin-update.component.css', '../../global-elements.css'],
    standalone: false
})
export class BinUpdateComponent {

  lastUrl:string = this.localStorageService.getItem('lastUrl')
  roles: any;
  readOnly: boolean = false;

  public userRole: string = '';

  public MarketSegment = MarketSegment;

   // Variable used when user change the address field
   public addressChange: boolean = false;

   // Variable used for the validation of the update
   validateCreate: boolean = false;

   // Variable used for the selected option of the bin-usage component
   public binUsageSelected: string = '';

   // Variables used by html to throw error messages
   public showErrorMessageEmptyInput: boolean = false;
   private systemMessage: string = '';

   // Variable for bin arrays
   public bin_array: any;
   public bin_model_array: any;

   private bin_id: string = '';

   public availableDevices: any[] = [];

   // Variables used for the client assiciate to the bin
    public associatedClientId: string = '';
    public thing_name: string = '';
    public redirectToCLientDeviceList: boolean = false;
    public redirectToDistributortDeviceList: boolean = false;
    public redirectToClientBinList: boolean = false;
    public originalBinName: string = "";

    public latitude: number = 0;
    public longitude: number = 0;
   public binGpsOriginal: any;
   public binUsage = BinUsage;
  public loadingDevices: boolean = false;
  public loadingPage: boolean = true;

   get marketSegmentOptions() {
     return (this.MarketSegment || []).map((option: any) => ({
       label: option.label,
       value: option.value,
     }));
   }

   get clientOptions() {
     return (this.cognitoService.clientsInfosArray || []).map((option: any) => ({
       label: option.legal_name,
       value: option.client_id,
     }));
   }

   get deviceOptions() {
     return (this.bin.device_array || []).map((option: any) => ({
       label: option.thing_name,
       value: option.thing_name,
     }));
   }
   constructor(public bin: BinsService,
              public iotService: IotService,
              public validationService: ValidationService,
              private router: Router,
              private localization: LocalizationService,
              private activatedRoute: ActivatedRoute,
              public alert: ModalAlertService,
              public cognitoService: CognitoService,
              public theme: ThemeService,
              private systemMessageService: SystemMessageService,
              private roleService: RoleService,
              private localStorageService: LocalStorageService,
              public dashboardService: DashboardService,
              private route: Router
    ){

   }

   // Function used to seperate the GPS coords
   splitGpsCoordinates(binGps: string) {
    if(binGps !== null) {
      // Dividir a string de coordenadas na vírgula
      const coordenadasArray = binGps.split(',');

      // Extrair os valores de latitude e longitude
      this.latitude = parseFloat(coordenadasArray[0]);
      this.longitude = parseFloat(coordenadasArray[1]);
    }
  }

  // Function used for client display, set the UI to readonly for select of thing names and bin models
  isReadOnly() {
    if (this.roles  && this.cognitoService.userType == 'client') {
      return true;
    } else {
      return false;
    }
  }

  async ngOnInit(): Promise<void> {
    this.loadingPage = true;
    try {
      // Get current user roles from DB
      this.roles = await this.roleService.getRoles();
      await this.cognitoService.getUserType();

      await this.cognitoService.confirmValidUser();

      // Check witch user type is the current user and get only infos he can associate bins
      switch(this.cognitoService.userType){
        // Remove the break because each one of hte two user type get the client list
        case 'muirwood':
        case 'client':
        case 'distributor':
          // Distributor user will be abble to associate a bin to his own distributor ID or clients
          await this.cognitoService.getClientsInfos();
          break;
      }
      // Check if the user roles are approved in this page
      this.cognitoService.getCurrentRole([environment.users.role.administrator, environment.users.role.client, environment.users.role.distributor], [environment.users.superAdmin, environment.users.standardUser, environment.users.supplier], true, this.roleService.roles);

      // preparing bin names list - this.bin.binsNameList - to be used on duplicated bin name validation
      await this.bin.generateBinNamesList();
      await this.bin.getBinsModel();
      // Get the param that was pass from the bin-list of the bin_id selected
      this.activatedRoute.params.subscribe(params => {
        this.bin_id = params['id']; // Set bin_model_id to the param:id receive whit url
      });

      // Get the selected bin
      await this.bin.getBinById(this.bin_id).then(async (response) => {
        this.bin_array = response;
        this.bin.bin_data = this.bin_array[0];
        this.binGpsOriginal = this.bin.bin_data.bin_gps;
        this.splitGpsCoordinates(this.binGpsOriginal)
        this.originalBinName = this.bin.bin_data.bin_name;

      });
      this.loadingDevices = true;
      const deviceList = await this.iotService.getThingListByClient(this.bin.bin_data.client_id);
      for (const row of deviceList) {
        this.availableDevices.push(row.thingName);
      }
      this.loadingDevices = false;
    } finally {
      this.loadingPage = false;
    }
    // Remove the 'lastUrl' item from the localStorage
    this.localStorageService.removeItem('lastUrl');

    // Switch statement based on the value of 'lastUrl'
    switch (this.lastUrl) {
      // If 'lastUrl' is "deviceList"
      case "deviceList":
        // Activate the "clients" state
        this.redirectToCLientDeviceList = true;
        this.redirectToClientBinList = false;
        this.redirectToDistributortDeviceList = false;;
      break;

      case "distributor-iot-dashboard" :
        this.redirectToDistributortDeviceList = true;
        this.redirectToCLientDeviceList = false;
        this.redirectToClientBinList = false;
        break;

      // If 'lastUrl' is "binList"
      case "binList":
        // Activate the "binList" state
        this.redirectToCLientDeviceList = false;
        this.redirectToClientBinList = true;
        this.redirectToDistributortDeviceList = false;
      break;

      // For any other value of 'lastUrl'
      default:
        // Deactivate both states
        this.redirectToCLientDeviceList = false;
        this.redirectToClientBinList = false;
        this.redirectToDistributortDeviceList = false;
      break;
    }

    if(this.bin.bin_data.thing_name){
      this.thing_name = this.bin.bin_data.thing_name;
      // Set a variable oldThingName in case of device change from the user
      this.bin.oldThingName = this.thing_name;
    }

    // Set the caller for localization service so he know who will call him
    this.localization.caller = 'bin-create';
    this.localization.initAutocomplete();

    console.log('bin_data: ', this.bin.bin_data.bin_usage)

    // Function trigger when user get alerted if he change active status then click on cancel
    this.alert.cancel$.subscribe(() => {
      let checkboxStatus = document.getElementById('checkboxStatus') as HTMLInputElement; // Set the a html variable of the checkbox for the status
      this.bin.bin_data.active = this.alert.active; // Set the bin_model_data active status to the good value

      // Will reset the active status to what it was before the alert was throw then set the checkbox to the proper value
      if(this.alert.active === 1 && checkboxStatus){
        checkboxStatus.checked = true;
      } else if(this.alert.active === 0 && checkboxStatus){
        checkboxStatus.checked = false;
      }
    });

    // Function automatically trigger when user click on confirm into the alert modal
    this.alert.confirmBin$.subscribe(async () => {
      this.bin.bin_data.active = this.alert.active; // Set the bin_model_data active status to the good value
    });
    // this.iotService.thingShadow.state.desired.config.upf = Number(this.iotService.thingShadow.state.desired.config.upf);
  }

  // Checks if the provided bin name already exists in the list of bin names.
  isTrashBinNameDuplicated(binName: string) {

      // Check if the list of bin names is not an array
      if (!Array.isArray(this.bin.binsNameList)) {
        console.error('The list of bin names is not an array.');
        return false;
      }

      // Checks if the bin_name already exists in the list
      return this.bin.binsNameList.includes(binName);
  }


  // Function triggered when user confirm update of the bin
  async onSubmit(){
    // Create a variable whit the current date
    const currentDate = new Date();
    const formattedDate = formatDate(currentDate, 'yyyyMMdd', 'en_US');

    // Set created and modified date to current date, modified is required event if it's not so the query won't break
    this.bin.bin_data.modified = parseInt(formattedDate, 10);
    // If user change the address input the localization will be check and set back
    if(this.addressChange){
      // Set bin_location to the variable in localization service that google return
      this.bin.bin_data.bin_location = this.localization.autoCompletionReturnGpsLocation;
      this.bin.bin_data.bin_address = this.localization.autoCompletionReturnAddress;
      this.bin.bin_data.bin_postal_code = this.localization.autoCompletionReturnPostalCode;
    }

    // Call the fonction to see if there is value on each inputs
    this.checkValidation();

    if(this.validateCreate){
      if (this.thing_name) {
        this.bin.bin_data.thing_name = this.thing_name;
      } else if (!this.bin.bin_data.thing_name && this.bin.oldThingName) {
        // Preserve existing association when no new device is selected.
        this.bin.bin_data.thing_name = this.bin.oldThingName;
      }
      // If there's device related to the bin model, set the thing_name in iotService then call the fonction to update the device association
      this.bin.thing_name = this.thing_name;
      this.bin.distributor_id = this.bin.selectedBinModel?.distributor_id || '';
      //Update auto collect if thing name is avalaible
      await this.bin.updateBin();
      const cleanedShadow = {
        state: {
          desired: this.iotService.thingShadow?.state?.desired || {}
        }
      };
      // If the bin isnt associated to a device, we dont have to updateThingShadow
      if(this.thing_name){
        let shadowUpdate = await this.iotService.updateThingShadow(this.thing_name,cleanedShadow);
        console.log(shadowUpdate)
      }


      // Call the function that create the bin in bin service

      sessionStorage.setItem('from','bin-update')
      switch (true) {
        case this.redirectToCLientDeviceList:
          this.router.navigate(['client-thing-list']);
        break;

        case this.redirectToDistributortDeviceList:
          this.router.navigate(['distributor-iot-dashboard']);
        break;

        case this.redirectToClientBinList && this.cognitoService.userType !== 'muirwood':
          this.router.navigate(['client-bin-dashboard']);
        break;

        case this.cognitoService.userType === 'muirwood' && !this.redirectToCLientDeviceList:
          this.returnToAdmin();
        break;

        case this.cognitoService.userType === 'distributor':
          this.returnDistributorBinList();
          break;

        default:
          this.returnClientBinList();
        break;
      }

    } else {
      // If system message have nothing it put a generic message
      if(this.systemMessage === ''){
        this.systemMessage = 'alert-danger-generic-message';
      }
      // Set the system message service to display the error to the user
      this.systemMessageService.selectRibbon('danger', this.systemMessage);
    }
  }

  // Function to validate latitude
  validateLatitude(input: number | null): boolean {
    // Check if input is null
    if (input === null) {
        return true; // Return true for null input
    }

    // Convert the number to a string for validation
    const inputAsString = input.toString();

    // Regular expression for latitude validation
    const regexLat = /^-?(?:90(?:\.0{1,18})?|[0-8]?\d(?:\.\d{1,18})?)$/;

    // Test if the input matches the latitude regex
    return regexLat.test(inputAsString);
  }

  // Function to validate longitude
  validateLongitude(input: number | null): boolean {
    // Check if input is null
    if (input === null) {
        return true; // Return true for null input
    }

    // Convert the number to a string for validation
    const inputAsString = input.toString();

    // Regular expression to validate longitude
    const regexLong = /^-?(?:180(?:\.0{1,18})?|(?:1[0-7]?\d|0?\d?\d)(?:\.\d{1,18})?)$/;

    // Test if the input matches the longitude regex
    return regexLong.test(inputAsString);
  }

  // Function in addition of validation service that put the variable validateCreate at rue if all variables are properly implemented
  checkValidation(){

    const isValidLatitude = this.validateLatitude(this.latitude);
    const isValidLongitude = this.validateLongitude(this.longitude);


    this.bin.bin_data.bin_gps = this.latitude + "," + this.longitude;

    let notDuplicatedBinName = false;

    // Checks if bin name has been changed
    switch(true) {
      // if bin name still the same - avoid duplicate bin name validation
      case this.originalBinName === this.bin.bin_data.bin_name:
        // Check if all required variables are not empty and validation errors are not present
        if(isValidLatitude && isValidLongitude && this.bin.bin_data.bin_name!=='' && this.bin.bin_data.bin_model_id !== '' && this.bin.bin_data.bin_usage !== '' && this.bin.bin_data.market_segment !== '' && this.bin.bin_data.client_id !== '' &&
          (this.validationService.validationErrorArray[0] === '' || this.validationService.validationErrorArray[0] === undefined))           {

            // Perform additional validation for the client ID
            this.ClientIdValidation();

          } else {
            if (!isValidLatitude) {
              this.systemMessage = 'invalidLatitude';
            } else if (!isValidLongitude) {
                this.systemMessage = 'invalidLongitude';
            } else {
                this.systemMessage = 'binCreateViewAlertEmptyInput';
            }
          }

      break;

      // if bin name has been changed
      case this.originalBinName !== this.bin.bin_data.bin_name:

        // Check if the bin name is not duplicated
        if(!this.isTrashBinNameDuplicated(this.bin.bin_data.bin_name)) {
          notDuplicatedBinName = true;

          // Check if all required variables are not empty and validation errors are not present
          if(isValidLatitude && isValidLongitude && notDuplicatedBinName && this.bin.bin_data.bin_name!=='' && this.bin.bin_data.bin_model_id !== '' && this.bin.bin_data.bin_usage !== '' && this.bin.bin_data.market_segment !== '' && this.bin.bin_data.client_id !== '' &&
            (this.validationService.validationErrorArray[0] === '' || this.validationService.validationErrorArray[0] === undefined)){
              // Perform additional validation for the client ID
              this.ClientIdValidation();
          } else {

            // Display an error message if any required variable is empty or validation errors are present
            if (!isValidLatitude) {
              this.systemMessage = 'invalidLatitude';
            } else if (!isValidLongitude) {
                this.systemMessage = 'invalidLongitude';
            } else {
                this.systemMessage = 'binCreateViewAlertEmptyInput';
            }
          }
        // If the bin name is duplicated
        } else {
          // Display an error message if the bin name is duplicated
          notDuplicatedBinName = false;
          this.systemMessage = 'binCreateViewAlertDuplicatedBinName';
        }
      break;
    }
  }

  // Function called to validate if the client_id was properly set
  ClientIdValidation(){
    switch(true){
      // Will check if the user type is muirwood or distributor, the client id need to be assign. if not there will be a message displayed
      case ((this.cognitoService.userType === 'muirwood' || this.cognitoService.userType === 'distributor') && this.bin.bin_data.client_id !== ''):
        // Set validation variable to true;
        this.validateCreate = true;
        break;

      // Will set the bin_data client_id variable to the client id if the user type is client
      case this.cognitoService.userType === 'client':
        // Set the bin_data client_id variable to the user client id
        this.bin.bin_data.client_id = this.cognitoService.clientId;
        // Set the validation variable to true
        this.validateCreate= true;
        break;

      // Goes into default if there is no client selected and user type is not client
      default:
        this.systemMessage = 'enterClient';
    }
  }

  // Function called when user select a bin model number to associate to th bin
  async binModelChange(){
    this.bin.binModelOrClientChange();
  }

  // Function called when user change the threshold input and won't let him to put threshold under 40% or over 90%
  thresholdChange(){
    if(this.bin.bin_data.threshold < 40 || this.bin.bin_data.threshold > 90){
      // If threshold is not in the range, throw an error message and set the threshold to the default value 80
      this.systemMessageService.selectRibbon('danger', 'thresholdBreakPoint');
      this.bin.bin_data.threshold = 80;
    }
  }

  // Functino called when user change the select of client
  async selectedClientChange(){
    if(this.bin.bin_data.bin_model_id !== ''){
      // If bin model select is not empty it will call his function to get all available device
      this.binModelChange();
    }
  }

  // Implemented by cancel button to return to the admin component
  returnToAdmin(){
    // Put a sessions store variable so admin component could know to return on bin-list
    sessionStorage.setItem("previous", "bin-list");
    sessionStorage.setItem("from", "bin-update"); // Variable used by bin-model-list html to show the proper message on success updating bin model
    this.router.navigate(['/admin']); // Return to admin component
  }

  // Function used by client user type to return to the client bin list
  returnClientBinList(){
    this.router.navigate(['/client-bin-dashboard']);
  }

  // Function used by client user type to return to the client bin list
  returnDistributorBinList(){
    this.router.navigate(['/bin-dashboard']);
  }

  // Function used for client users to redirect to his thing list
  returnDeviceClientList() {
    this.router.navigate(['client-thing-list']);
  }

  // Function called when user touch to the address input
  onInputAddressKeydown(event: KeyboardEvent): void {
    this.addressChange = true; // If user change something on the address input

    // If user press enter when he's in the address field the form won't submit
    if(event.key === 'Enter'){
      event.preventDefault();
    }
  }

  // Function used to return bin model ID
  trackBinModelId(option: any): string {
    return option.bin_model_id;
  }
}
